import "./CompDropdown.css"
import React, { useState, useRef, useEffect } from "react";
import { GoChevronDown } from "react-icons/go";

import { URL_HELPER } from "../utils/constants";

const CompDropdown = ({ competitions, title, changeActiveCompetition }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleCompClick = (competition) => {
        window.history.replaceState(null, `Competition ${competition.compId}`, getHref(competition));
        changeActiveCompetition(competition.compId);
        setIsOpen(false);
    }

    const renderCompItems = () => {
        
        if (!competitions || competitions.length === 0) {
            return (
                <div className="dropdown-empty">
                    No competitions available
                </div>
            );
        }

        return competitions.map((competition, index) => {
            const statusClass = getCompetitionStatusClass(competition);
            const statusText = getCompetitionStatusText(competition);

            return (
                <div
                    key={`comp_${competition.compId || index}`}
                    className="dropdown-item"
                    onClick={() => handleCompClick(competition)}
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            handleCompClick(competition);
                        }
                    }}
                >
                    <div className="dropdown-item-container">
                        <div className={`status-circle ${statusClass}`}></div>
                        <div className="competition-info">
                            <h4 className="competition-title">{competition.title}</h4>
                            <div className="competition-meta">
                                <div className="meta-item">
                                    <span>📊</span>
                                    <span>{statusText}</span>
                                </div>
                                {competition.wordLength && (
                                    <div className="meta-item">
                                        <span>📏</span>
                                        <span>{competition.wordLength} letters</span>
                                    </div>
                                )}
                                {competition.createdBy && (
                                    <div className="meta-item">
                                        <span>👤</span>
                                        <span>{competition.createdBy}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )
        });
    }

    const getCompetitionStatusClass = (competition) => {
        if (competition.finished) return "status-finished";
        if (competition.started === false) return "status-starting";
        return "status-running";
    }

    const getCompetitionStatusText = (competition) => {
        if (competition.finished) return "Finished";
        if (competition.started === false) return "Starting Soon";
        return "Running";
    }

    const getHref = (competition) => {
        const baseUrl = window.location.href.split("/")[0];
        return `${baseUrl}/${URL_HELPER.URL_COMPETITION_PARAM}${competition.compId}`;
    }

    return (
        <div className="competition-dropdown" ref={dropdownRef}>
            <button
                className={`dropdown-button ${isOpen ? 'open' : ''}`}
                onClick={() => {
                    setIsOpen(!isOpen);
                }}
                aria-expanded={isOpen}
                aria-haspopup="true"
            >
                <span>{title}</span>
                <GoChevronDown className="dropdown-icon" size={16} />
            </button>

            <div className={`dropdown-menu ${isOpen ? 'open' : ''}`}>
                {renderCompItems()}
            </div>
        </div>
    )
}

export default CompDropdown;